module.exports = __webpack_public_path__ + "static/media/daily late report.68d24d4b.svg";